var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleScholarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M256 411.12L0 202.667 256 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#356ac3",
    d: "M256 411.12l256-208.453L256 0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#a0c3ff",
    cx: 256,
    cy: 362.667,
    r: 149.333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#76a7fa",
    d: "M121.037 298.667c23.968-50.453 75.392-85.334 134.963-85.334s110.995 34.881 134.963 85.334H121.037z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleScholarLogo);
export default __webpack_public_path__ + "static/media/Google_Scholar_logo.40e3b4f719a57a3d034b854054a25c66.svg";
export { ForwardRef as ReactComponent };